import * as tslib_1 from "tslib";
import getCASMailbox2Operation from 'owa-service/lib/operation/getCASMailbox2Operation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export function getCASMailbox2() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        Header: getJsonRequestHeader(),
                        Options: {
                            ActiveSyncDebugLogging: true,
                        },
                    };
                    return [4 /*yield*/, getCASMailbox2Operation(request)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=getCASMailbox2.js.map